import { render, staticRenderFns } from "./UpdateLocalItemPopup.vue?vue&type=template&id=4f34b219&"
import script from "./UpdateLocalItemPopup.vue?vue&type=script&lang=js&"
export * from "./UpdateLocalItemPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f34b219')) {
      api.createRecord('4f34b219', component.options)
    } else {
      api.reload('4f34b219', component.options)
    }
    module.hot.accept("./UpdateLocalItemPopup.vue?vue&type=template&id=4f34b219&", function () {
      api.rerender('4f34b219', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/UpdateLocalItemPopup.vue"
export default component.exports